import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const StartupsPage = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="min-h-screen bg-page-bg flex items-center justify-center px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="text-center max-w-2xl">
        <h1 className="font-bayon text-4xl mb-6 text-black">Startups</h1>
        <p className="font-k2d text-lg mb-6 text-gray-800">
          This is the Startups page. Coming soon!
        </p>
        <button 
          onClick={() => navigate('/', { state: { fromDetail: true } })} 
          className="px-6 py-3 bg-black text-white rounded-lg font-k2d hover:bg-gray-800 transition-colors text-lg"
        >
          Back to Home
        </button>
      </div>
    </motion.div>
  );
};

export default StartupsPage;
